export async function createCheckoutSession(
  priceId: string,
  type: "one-time" | "recurring" | "subscription",
  customerEmail: string,
  metadata?: any,
  successUrl?: string
) {
  const baseUrl = 'https://nkuqcyelxgyihrxyvitb.supabase.co/functions/v1/create-checkout-session';
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  const res = await fetch(baseUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${supabaseAnonKey}`,
    },
    body: JSON.stringify({ priceId, type, customerEmail, metadata, successUrl }),
  });

  if (!res.ok) {
    let errorMsg = `Failed to create checkout session: ${res.status} ${res.statusText}`;
    try {
      const errJson = await res.json();
      if (errJson?.error) errorMsg += ` - ${errJson.error}`;
    } catch {}
    throw new Error(errorMsg);
  }

  let data;
  try {
    data = await res.json();
  } catch (err) {
    throw new Error('Response is not valid JSON');
  }

  if (!data.url) {
    throw new Error('No checkout URL returned from server');
  }

  return data.url;
}